import { Component, OnInit } from "@angular/core";
import { MenuService } from "../../services/menu.service";
import { Menu } from "../../interfaces/menu";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"]
})
export class MenuComponent implements OnInit {
  menu: Menu[];
  activeMenuIndex = 0;

  constructor(private ms: MenuService) {
    this.ms.getMenu().subscribe(res => {
      this.menu = res ? res.data : null;
    });
  }

  ngOnInit() {}
}
